import "../style/exam-result/ER_Info.css";
import img1 from "../../assets/exam-result/45e08061b2a29b0fb3c4200af283f0be.png";

const ER_Info = ({ data }) => {
  data = data || {};
  return (
    <div className="ER_Info">
      <div className="ER-Info-text">
        <div className="ER-Info-text-row">
          <div className="ER-Info-text-row-item ER-Info-text-row-item-name">
            کارنامه دانش آموزی {data.title}
          </div>
          <div className="ER-Info-text-row-item ER-Info-text-row-item-date">
            <div className="ER-Info-text-row-item-title">
              تاریخ برگزاری آزمون نهایی:
            </div>
            <div className="ER-Info-text-row-item-value"> {data.date}</div>
          </div>
          <div className="ER-Info-text-row-item ER-Info-text-row-item-userNum">
            <div className="ER-Info-text-row-item-title">
              تعداد شرکت کنندگان:
            </div>
            <div className="ER-Info-text-row-item-value">
              {" "}
              {data.user_num} دانش آموز
            </div>
          </div>
        </div>
        <div className="ER-Info-text-row">
          <div className="ER-Info-text-row-item ER-Info-text-row-item-creator">
            {data.creator?.name}
          </div>
          <div className="ER-Info-text-row-item ER-Info-text-row-item-user-name">
            <div className="ER-Info-text-row-item-title">{data.user_name}</div>
          </div>
          <div className="ER-Info-text-row-item ER-Info-text-row-item-userCode">
            <div className="ER-Info-text-row-item-title">شماره داوطلب:</div>
            <div className="ER-Info-text-row-item-value">
              {data.user_number}
            </div>
          </div>
        </div>
        <div className="ER-Info-text-btn-container">
          <div className="ER-Info-text-btn">چاپ کارنامه</div>
        </div>
      </div>
      <div className="ER-Info-QRcode">
        <img src={img1} alt="QR-code" className="ER-Info-QRcode-img" />
        <div className="ER-Info-QRcode-text">
          بررسی صحت کارنامه با اسکن کد QR
        </div>
      </div>
    </div>
  );
};

export default ER_Info;
